export default __webpack_public_path__ + "static/media/Mobile POS.62bba8d0.png";